module.exports = __webpack_public_path__ + "static/img/15.3075899.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jlbs/15.png
// module id = Ds1O
// module chunks = 0